/**
 * The feature showcase.
 *
 * The old site stacked twelve separate 400px cards, one per capability, which
 * came to roughly 2500px of scroll on desktop and 5400px on mobile. The same
 * twelve capabilities live here, grouped into four themes behind tabs.
 *
 * Copy targets movement studios — pilates, spinning, group workouts — so the
 * vocabulary throughout is אימונים and מתאמנים, not תורים and לקוחות.
 */

export const featureThemes = [
  {
    id: "schedule",
    label: "לו״ז ואימונים",
    icon: "IconCalendar",
    title: "הלו״ז מנהל את עצמו",
    description:
      "המתאמנות נרשמות, מעבירות ומבטלות אימונים לבד. אתם רואים יומן מסודר ונשארים בשליטה מלאה על שעות הפעילות.",
    image: require("@/assets/schedule-appointment.jpg"),
    imageAlt: "מסך לוח האימונים של הסטודיו באפליקציית אפלאטס",
    bullets: [
      {
        title: "הרשמה לאימון",
        text: "ממשק פשוט וידידותי להרשמה ולשינוי אימונים, בלי שיחות טלפון ובלי הודעות.",
      },
      {
        title: "שליטה ובקרה",
        text: "הרחבת שעות פעילות, שריון שעות, דחיית כל האימונים או סגירת יום שלם.",
      },
      {
        title: "רשימת המתנה",
        text: "האימון מלא? מתאמנות נרשמות לשעות שמתאימות להן ומקבלות עדכון כשמתפנה מקום.",
      },
      {
        title: "קבוצות אימון",
        text: "אימונים קבוצתיים ואישיים, עם הצטרפות עצמאית של המתאמנות לכל קבוצה.",
      },
    ],
  },
  {
    id: "clients",
    label: "מתאמנים ותקשורת",
    icon: "IconBell",
    title: "המתאמנות תמיד מעודכנות",
    description:
      "תזכורות, שינויים ועדכונים נשלחים אוטומטית. פחות אי-הגעות, פחות בירורים בוואטסאפ.",
    image: require("@/assets/notification-center.jpg"),
    imageAlt: "מרכז העדכונים באפליקציית אפלאטס",
    bullets: [
      {
        title: "עדכונים בזמן אמת",
        text: "תזכורת לפני האימון, והודעה אוטומטית על כל שינוי או ביטול.",
      },
      {
        title: "מרכז עדכונים",
        text: "כל ההודעות של המתאמנת במקום אחד — אימונים, מנויים והתראות מהסטודיו.",
      },
      {
        title: "נגישות ורב-לשוניות",
        text: "תמיכה בכמה שפות, ומענה מלא למתאמנות עם ליקויי שמיעה ודיבור.",
      },
      {
        title: "הצהרות בריאות",
        text: "הצהרות, אישורים רפואיים והסכמת הורים למתאמנים קטינים — דיגיטלי וחתום.",
      },
    ],
  },
  {
    id: "business",
    label: "מנויים ומעקב",
    icon: "IconChart",
    title: "ניהול דיגיטלי, ללא ניירת",
    description:
      "כרטיסיות, מנויים, מדידות והתקדמות",
    image: require("@/assets/subscriptions.jpg"),
    imageAlt: "מסך מנויי הכרטיסיות של מתאמנת באפליקציית אפלאטס",
    bullets: [
      {
        title: "מנויים וכרטיסיות",
        text: "ניקוב אוטומטי בכל אימון, מעקב יתרות ותאריכי סיום, והתראה לפני שנגמר.",
      },
      {
        title: "מדידות גוף",
        text: "מדידות ומעקב התקדמות לכל מתאמנת, עם היסטוריה מלאה.",
      },
      {
        title: "פעילות וביצועים",
        text: "כמה אימונים בשבוע, אילו שעות מתמלאות ומי הפסיקה להגיע.",
      },
      {
        title: "הכל מכל מקום",
        text: "כל המידע זמין באפליקציה בנייד, בכל שעה ומכל מקום.",
      },
    ],
  },
  {
    id: "brand",
    label: "אפליקציה ממותגת",
    icon: "IconPalette",
    title: "אפליקציה עם שם ולוגו הסטודיו",
    description:
      "לא עוד מערכת גנרית. אפליקציה נפרדת בחנויות, עם המותג של הסטודיו עליה.",
    image: require("@/assets/custom-app.jpg"),
    imageAlt: "אפליקציה ממותגת עם הלוגו והצבעים של הסטודיו",
    bullets: [
      {
        title: "השם והלוגו שלכם",
        text: "אייקון, שם ומסך פתיחה של הסטודיו — המתאמנות מורידות את האפליקציה שלכם.",
      },
      {
        title: "צבעים ועיצוב",
        text: "הצבעים והתמונות של הסטודיו לאורך כל האפליקציה.",
      },
      {
        title: "נוכחות בחנויות",
        text: "האפליקציה עולה ל-App Store ול-Google Play על שם הסטודיו.",
      },
      {
        title: "אנחנו מטפלים בהכל",
        text: "הקמה, העלאה ועדכונים שוטפים — אתם רק שולחים לוגו.",
      },
    ],
  },
];
